import axios from 'axios'

let savedToken = window.localStorage.getItem('token')
let tokenData = savedToken ? JSON.parse(savedToken) : {}

if (tokenData && tokenData.expiration) {
  tokenData.expiration = new Date(tokenData.expiration)
}

export function setToken(t, e) {
  if (!t || !t.authorizationToken){
    throw(new Error('Invalid request to update token'))
  }

  tokenData = {
    expiration: e || new Date((new Date()).getTime() + 30 * 60 * 1000),
    authorizationToken: t.authorizationToken,
    refreshToken: t.refreshToken
  }
  window.localStorage.setItem('token', JSON.stringify(tokenData))
}

export function clearToken() {
  console.log('Clearing token.')
  window.localStorage.removeItem('token')
  tokenData = {}
}

export function getToken(cb) {
  let user = window.localStorage.getItem("user") 
  let userData = user ? JSON.parse(user) : {}

  return new Promise((resolve, reject) => {
    if (tokenData.authorizationToken) {
      var now = new Date();
      if (now < tokenData.expiration) {
        if (cb) cb(tokenData.authorizationToken, tokenData.refreshToken)
        resolve(tokenData.authorizationToken, tokenData.refreshToken)
        return
      }
    }

    if (tokenData.refreshToken || (userData && userData.user && Object.keys(userData).length > 0)) {
      // console.log('refreshing token')
      axios({
        method: 'GET',
        url: `${ window.settings.apiBaseUrl }/identity/refresh/${ tokenData.refreshToken || userData.user.refreshToken }`,
      }).then( res => {
        var d = res.data && {
          authorizationToken: res.data.authorization_token,
          refreshToken: res.data.refresh_token
        }
        setToken(d)
        if (cb) cb(d.authorizationToken, d.refreshToken)
        resolve(d.authorizationToken, tokenData.refreshToken)
      }).catch(err => {
        console.error('Error refreshing token', err)
        clearToken()
        reject(err)
      })
      return
    }

    // If user, remove user
    var url = 
      window.SERVER_SIDE_RENDERING ? 
        `${ window.settings.apiBaseUrl }/identity/server-token` :
        `${ window.settings.apiBaseUrl }/identity/anonymous-token`

    // Fetch token
    axios({
      method: "GET",
      url: url,
      params: { site: window.settings.internalName },
      headers: {
        "x-api-key": window.settings.baseAPIKey
      }
    })
    .then(res => {
      var d = res.data && { authorizationToken: res.data.authorizationToken };
      setToken(d, Date() + 1000 * 60 * 60 * 24 * 365);
      if (cb) cb(d.authorizationToken, d.refreshToken);
      resolve(d.authorizationToken, d.refreshToken);
    })
    .catch(err => {
      console.error("Error fetching anonymous token", err);
      reject(err);
    });
  })
}